import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { CommonService } from "../../core/services/common.service";
import { ListValueService } from "../../core/services/list-value.service";
import { ToastrAlertService } from "../../core/services/toastrAlert.service";
import { SimilarFields } from "src/app/certificates/models";
import { dynamicsFields } from "src/app/coc/models/dynamicsFields";
import { CertificatesService } from "src/app/certificates/services/certificates.service";
import { AppConstants } from "src/app/constants/app.constants";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-dynamic-fields",
  templateUrl: "./dynamic-fields.component.html",
  styleUrls: ["./dynamic-fields.component.scss"],
})
export class DynamicFieldsComponent implements OnInit {
  @Input() fields: any[];
  @Input() operation: string;
  @Input() bastidor: string;
  @Input() certificate: string;
  @Input() reform: string;
  @Input() tmotor: string;
  @Input() stateToPFAndWatchBoth: boolean;

  @Output() downloadFileEvent = new EventEmitter<any>();

  files: any[] = [];

  dbLists: any[] = [];
  dbListsLoaded: any[] = [];

  similarFields: SimilarFields[] = [
    {
      id: "AL_0004",
      type: "text",
      text: "DESCRIPCIÓN REFORMA",
    },
    {
      id: "FI_0001",
      type: "file",
      text: "FICHA ITV",
    },
    {
      id: "FI_0003",
      type: "file",
      text: "CERTIFICADO DE TALLER",
    },
  ];

  constructor(
    private commonService: CommonService,
    private listValueService: ListValueService,
    private toastrAlertService: ToastrAlertService,
    private certificatesService: CertificatesService,
    private translateService: TranslateService
  ) {}

  ngOnInit(): void {
    this.sortByReforma();
    if (this.certificate?.includes("RE")) {
      this.certificate = "RE";
    }
    this.setStaticLists();
    if (this.operation == "edit") {
      this.getDynamicDBLists();
    }
  }

  private convierteStrCodigoReformaEnFloat(strCodigoReforma: string): number {
    let floatCodigoReforma: number = 0.0;
    if (strCodigoReforma == null) return floatCodigoReforma;
    if (strCodigoReforma.trim().length == 0) return floatCodigoReforma;
    let partes: string[] = strCodigoReforma.split("-");
    if (partes.length < 2) return floatCodigoReforma;
    if (partes.length > 0) {
      let reform = partes[0].split(".");
      if (reform.length > 1 && reform[1].trim().length == 1)
        partes[0] = reform[0] + ".0" + reform[1].trim();
    }
    floatCodigoReforma = parseFloat(partes[0]);
    return floatCodigoReforma;
  }

  private sortByReforma() {
    this.fields.sort((a, b) => {
      // Primero, ordena por dpReforma
      const comparacionReforma =
        this.convierteStrCodigoReformaEnFloat(a.dpReforma) -
        this.convierteStrCodigoReformaEnFloat(b.dpReforma);

      // Si dpReforma es el mismo, ordena por ccPosicion
      if (
        comparacionReforma === 0 &&
        a.camposdisponibles != null &&
        b.camposdisponibles != null &&
        a.camposdisponibles.ccPosicion != null &&
        b.camposdisponibles.ccPosicion != null
      ) {
        return a.camposdisponibles.ccPosicion - b.camposdisponibles.ccPosicion;
      }

      return comparacionReforma;
    });
  }

  handleFileInput(fileInput: any, index: number) {
    if (fileInput.target.files && fileInput.target.files[0]) {
      let name = fileInput.target.files[0].name;
      const reader = new FileReader();
      reader.onload = (e: any) => {
        let blob = this.commonService.castToBlob(e.target.result);
        let pos = this.files.findIndex((e) => e.index == index);
        if (pos >= 0) {
          this.files.splice(pos, pos + 1);
        }
        this.files.push({
          index: index,
          name: name,
          blob: blob,
        });
        this.fields[this.files[this.files.length - 1].index].dpFichero = name;
        this.fields[this.files[this.files.length - 1].index].dpValor = name;
        this.fillSimilarField(
          "file",
          this.fields[this.files[this.files.length - 1].index],
          blob,
          name
        );
      };

      reader.readAsDataURL(fileInput.target.files[0]);
    }
  }

  public getDynamicDBLists(): void {
    this.fields.forEach((e, index) => {
      if (e.camposdisponibles && e.camposdisponibles.cdTipo == "DBLIST") {
        this.getDBList(e.camposdisponibles.cdListadb, index);
      } else if (e.camposdisponibles && e.camposdisponibles.cdTipo == "LIST") {
        this.loadListCamposLI(e.camposdisponibles.cdId, index);
      }
    });

    return null;
  }

  private setStaticLists() {
    this.fields.forEach((e, index) => {
      if (e.camposdisponibles && e.camposdisponibles.cdTipo == "STATICLIST") {
        this.dbLists[index] = e.camposdisponibles.cdListadb;
        this.dbListsLoaded[index] = {
          data: e.cdListadb,
          loaded: true,
        };
      }
    });
  }

  public getValueStaticList(list: any[], value: string) {
    return list.find((e) => e.valor == value);
  }

  public getValueLabelStaticList(list: any[], value: string) {
    let object = list.find((e) => e.valor == value);
    if (object != null && object.label != null) {
      return object.label;
    }
    return value;
  }

  public valueSelector(event: any, index: number) {
    if (event.item != undefined) {
      this.fields[index].dpValor = event.item;
    } else if (event.item == undefined) {
      this.fields[index].dpValor = "";
    }
  }

  private loadListCamposLI(id: string, index: number): void {
    this.listValueService.listCamposLI(id).subscribe(
      (data) => {
        this.dbLists[index] = data;
        this.dbListsLoaded[index] = {
          data: data,
          loaded: true,
        };
        this.getObjectOfList(data, index);
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  public getDBList(type: string, pos: number): void {
    switch (type) {
      case "TCAMBIO_DENOM":
        this.getListDenominacion(pos);
        break;
      case "TCAMBIO_SIGLA":
        this.getListSiglas(pos);
        break;
      case "TMOTOR":
        this.getTMotorList(pos);
        break;
      case "CATEGORIAS":
        this.getlistCategorias(pos);
        break;
      case "CLASIFICACIONES":
        this.getClasificaciones(pos);
        break;
      case "INDICE_CARGA":
        this.getIndiceDeCarga(pos);
        break;
      case "INDICE_VELOCIDAD":
        this.getIndiceDeVelocidad(pos);
        break;
      case "NEUMATICO_ANCHO":
        this.getNeumaticoAncho(pos);
        break;
      case "NEUMATICO_PERFIL":
        this.getListNeumaticoPerfil(pos);
        break;
      case "NEUMATICO_DIAMETRO":
        this.getlistDiametroNeumatico(pos);
        break;
      case "NEUMATICO_GARGANTA":
        this.getlistGargantaNeumatico(pos);
        break;
      case "NEUMATICO_BOMBEO":
        this.getlistBombeoNeumatico(pos);
        break;
      case "TPLACA":
        this.getListTipoPlaca(pos);
        break;
      case "MOTIVO_REEDICION":
        this.getListMotivoReedicion(pos);
        break;
      default:
        break;
    }
    return;
  }

  getObjectOfList(list: any[], index: number) {
    this.fields[index].dpValor = list.find(
      (e) => e.valor == this.fields[index].dpValor
    );
  }

  isLoaded(index: number) {
    if (this.dbListsLoaded[index] && this.dbListsLoaded[index].loaded) {
      this.dbLists[index] = this.dbListsLoaded[index].data;
      this.getObjectOfList(this.dbLists[index], index);
      return true;
    }
    return false;
  }

  getListSiglas(index: number) {
    if (!this.isLoaded(index)) {
      let reform = this.fields[index].dpReforma.split("-")[0]?.trim();
      this.listValueService
        .listSiglas(this.bastidor, this.certificate, reform, "")
        .subscribe(
          (data) => {
            if (data.length > 0) {
              this.dbLists[index] = data;
              this.dbListsLoaded[index] = {
                data: data,
                loaded: true,
              };
            } else {
              this.dbLists[index] = [];
              this.dbListsLoaded[index] = {
                data: [],
                loaded: true,
              };
            }

            this.getObjectOfList(data, index);
          },
          (err) => {
            this.toastrAlertService.toastrFail(err.error.mensaje);
          }
        );
    }
  }

  getListDenominacion(index: number) {
    if (!this.isLoaded(index)) {
      let reform = this.fields[index].dpReforma.split("-")[0]?.trim();
      this.listValueService
        .listDenominaciones(
          this.bastidor,
          this.certificate,
          reform,
          this.tmotor ? this.tmotor : ""
        )
        .subscribe(
          (data) => {
            if (data.length > 0) {
              this.dbLists[index] = data;
            } else {
              this.dbLists[index] = [];
            }
            this.dbListsLoaded[index] = {
              data: this.dbLists[index],
              loaded: true,
            };
            this.getObjectOfList(this.dbLists[index], index);
          },
          (err) => {
            this.toastrAlertService.toastrFail(err.error.mensaje);
          }
        );
    }
  }

  getlistCategorias(index: number) {
    if (!this.isLoaded(index)) {
      this.listValueService.listCategorias().subscribe(
        (data) => {
          this.dbLists[index] = data;
          this.dbListsLoaded[index] = {
            data: data,
            loaded: true,
          };
          this.getObjectOfList(data, index);
        },
        (err) => {
          this.toastrAlertService.toastrFail(err.error.mensaje);
        }
      );
    }
  }

  getlistBombeoNeumatico(index: number) {
    if (!this.isLoaded(index)) {
      this.listValueService.listBombeoNeumatico().subscribe(
        (data) => {
          this.dbLists[index] = data;
          this.dbListsLoaded[index] = {
            data: data,
            loaded: true,
          };
          this.getObjectOfList(data, index);
        },
        (err) => {
          this.toastrAlertService.toastrFail(err.error.mensaje);
        }
      );
    }
  }

  getlistGargantaNeumatico(index: number) {
    if (!this.isLoaded(index)) {
      this.listValueService.listGargantaNeumatico().subscribe(
        (data) => {
          this.dbLists[index] = data;
          this.dbListsLoaded[index] = {
            data: data,
            loaded: true,
          };
          this.getObjectOfList(data, index);
        },
        (err) => {
          this.toastrAlertService.toastrFail(err.error.mensaje);
        }
      );
    }
  }

  getTMotorList(index: number) {
    if (!this.isLoaded(index)) {
      this.listValueService.listMotores(this.bastidor).subscribe(
        (data) => {
          this.dbLists[index] = data[0];
          this.dbListsLoaded[index] = {
            data: data,
            loaded: true,
          };
          this.getObjectOfList(data, index);
        },
        (err) => {
          this.toastrAlertService.toastrFail(err.error.mensaje);
        }
      );
    }
  }

  getClasificaciones(index: number) {
    if (!this.isLoaded(index)) {
      this.listValueService.listClasificaciones().subscribe(
        (data) => {
          this.dbLists[index] = data;
          this.dbListsLoaded[index] = {
            data: data,
            loaded: true,
          };
          this.getObjectOfList(data, index);
        },
        (err) => {
          this.toastrAlertService.toastrFail(err.error.mensaje);
        }
      );
    }
  }

  getIndiceDeCarga(index: number) {
    if (!this.isLoaded(index)) {
      this.listValueService.listIndiceCarga().subscribe(
        (data) => {
          this.dbLists[index] = data;
          this.dbListsLoaded[index] = {
            data: data,
            loaded: true,
          };
          this.getObjectOfList(data, index);
        },
        (err) => {
          this.toastrAlertService.toastrFail(err.error.mensaje);
        }
      );
    }
  }

  getIndiceDeVelocidad(index: number) {
    if (!this.isLoaded(index)) {
      this.listValueService.listIndiceVelocidad().subscribe(
        (data) => {
          this.dbLists[index] = data;
          this.dbListsLoaded[index] = {
            data: data,
            loaded: true,
          };
          this.getObjectOfList(data, index);
        },
        (err) => {
          this.toastrAlertService.toastrFail(err.error.mensaje);
        }
      );
    }
  }

  getNeumaticoAncho(index: number) {
    if (!this.isLoaded(index)) {
      this.listValueService.listAnchoNeumatico().subscribe(
        (data) => {
          this.dbLists[index] = data;
          this.dbListsLoaded[index] = {
            data: data,
            loaded: true,
          };
          this.getObjectOfList(data, index);
        },
        (err) => {
          this.toastrAlertService.toastrFail(err.error.mensaje);
        }
      );
    }
  }

  getListNeumaticoPerfil(index: number) {
    if (!this.isLoaded(index)) {
      this.listValueService.listPerfilNeumatico().subscribe(
        (data) => {
          this.dbLists[index] = data;
          this.dbListsLoaded[index] = {
            data: data,
            loaded: true,
          };
          this.getObjectOfList(data, index);
        },
        (err) => {
          this.toastrAlertService.toastrFail(err.error.mensaje);
        }
      );
    }
  }

  getlistDiametroNeumatico(index: number) {
    if (!this.isLoaded(index)) {
      this.listValueService.listDiametroNeumatico().subscribe(
        (data) => {
          this.dbLists[index] = data;
          this.dbListsLoaded[index] = {
            data: data,
            loaded: true,
          };
          this.getObjectOfList(data, index);
        },
        (err) => {
          this.toastrAlertService.toastrFail(err.error.mensaje);
        }
      );
    }
  }
  getListTipoPlaca(index: number) {
    if (!this.isLoaded(index)) {
      this.listValueService.listTipoPlaca().subscribe(
        (data) => {
          let castedData = [];
          data.forEach((e) => {
            castedData.push({ valor: e.ValorPlaca, desc: e.TipoPlaca });
          });
          this.dbLists[index] = castedData;
          this.dbListsLoaded[index] = {
            data: castedData,
            loaded: true,
          };
          this.getObjectOfList(castedData, index);
        },
        (err) => {
          this.toastrAlertService.toastrFail(err.error.mensaje);
        }
      );
    }
  }

  getListMotivoReedicion(index: number) {
    if (!this.isLoaded(index)) {
      this.listValueService.listMotivosReedicion().subscribe(
        (data) => {
          let castedData = [];
          data.forEach((e) => {
            castedData.push({ valor: e.mrId, desc: e.mrDesc });
          });
          this.dbLists[index] = castedData;
          this.dbListsLoaded[index] = {
            data: castedData,
            loaded: true,
          };
          this.getObjectOfList(castedData, index);
        },
        (err) => {
          this.toastrAlertService.toastrFail(err.error.mensaje);
        }
      );
    }
  }

  downloadFile(field: any) {
    this.downloadFileEvent.emit(field);
  }

  public changeValue(e, field): void {
    field.dpValor = e.target.value;
  }

  public checkifHasToHide(field): boolean {
    if (field.ccCampovinculado) {
      let item = this.fields.find(
        (item) =>
          item.camposdisponibles != null &&
          item.camposdisponibles.cdId === field.ccCampovinculado &&
          item.dpReforma === field.dpReforma
      );
      if (item && item.dpValor == "si" && field.ccValorvinculacion == "S") {
        return true;
      } else if (
        item &&
        item.dpValor == "no" &&
        field.ccValorvinculacion == "N"
      ) {
        return true;
      } else {
        return false;
      }
    }
    return true;
  }

  private validateLengthOfString(value: string): boolean {
    if (value && value.length > 256) {
      let text = this.translateService.instant("messages.fieldsErrorMaxLength");
      this.toastrAlertService.toastrFail(
        text +
          "256 caracteres, el texto será recortado al tamaño máximo permitido"
      );
      return false;
    }
    return true;
  }

  public fillSimilarField(
    type: string,
    element: dynamicsFields,
    file?: any,
    name?: string
  ): void {
    let fieldSimilar;
    switch (type) {
      case "text":
        if (!this.validateLengthOfString(element.dpValor)) {
          element.dpValor = element.dpValor.substring(0, 256);
        }
        fieldSimilar = this.similarFields.find(
          (item) => item.id === element.camposdisponibles.cdId
        );
        if (fieldSimilar) {
          let itemsToSave = this.fields.filter(
            (e) => e.camposdisponibles.cdId === element.camposdisponibles.cdId
          );
          if (itemsToSave && itemsToSave.length > 0) {
            itemsToSave.forEach((e) => {
              e.dpValor = element.dpValor;
            });
          }
        }
        break;
      case "file":
        fieldSimilar = this.similarFields.find(
          (item) => item.id === element.camposdisponibles.cdId
        );
        if (fieldSimilar) {
          let indexes = this.findAllIndexes(this.fields, fieldSimilar.id);
          indexes.forEach((element) => {
            let pos = this.files.findIndex((e) => e.index == element);
            if (pos >= 0) {
              this.files.splice(pos, pos + 1);
            }
            this.files.push({
              index: element,
              name: name,
              blob: file,
            });
            this.fields[this.files[this.files.length - 1].index].dpFichero =
              name;
          });
        }

        break;
      default:
        break;
    }
  }

  private findAllIndexes(arr: dynamicsFields[], value) {
    return Array.from(arr.keys()).filter(
      (i) => arr[i].camposdisponibles.cdId === value
    );
  }

  public getInfoOfACCFields(element: any) {
    this.certificatesService.getInfoOfACCFields(element.dpValor).subscribe(
      (data) => {
        this.toastrAlertService.toastrInfo(data.mensaje);
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  public setNumber(field: any) {
    if (field.dpValor && field.dpValor < AppConstants.minNumPuertas) {
      let message =
        field.dpCampo + this.translateService.instant("messages.numeroMinInt");
      this.toastrAlertService.toastrFail(message);
      field.dpValor = AppConstants.defaultNumPuertas;
    }
  }

  public convertFileName(fileName: string): string {
    if (this.stateToPFAndWatchBoth) {
      let regex = new RegExp("_", "g");
      return fileName.replace(regex, "-");
    } else {
      return fileName;
    }
  }
}
